const HIGHLIGHT_CLASS = 'verification-target-highlight'

/** Scrolls to a verification card and briefly highlights it so the jump is easy to spot. */
export function scrollToVerificationTarget(targetId: string) {
  document.querySelectorAll(`.${HIGHLIGHT_CLASS}`).forEach((element) => {
    element.classList.remove(HIGHLIGHT_CLASS)
  })

  const element = document.getElementById(targetId)
  if (!element) return

  element.scrollIntoView({ behavior: 'smooth', block: 'start' })
  element.classList.add(HIGHLIGHT_CLASS)

  const clearHighlight = () => {
    element.classList.remove(HIGHLIGHT_CLASS)
    element.removeEventListener('animationend', clearHighlight)
  }
  element.addEventListener('animationend', clearHighlight)

  if (element instanceof HTMLElement) {
    element.focus({ preventScroll: true })
  }
}
